import {Nav} from "../../../common/nav";
import {resolve} from "../../../container";
import {customElement, property} from "lit/decorators.js";
import {UnLitElement} from "../../../common/elements";
import {clickEventAlreadyHandledByChild} from "../../../common/utils/events";

@customElement("eop-background-link")
export class EopBackgroundLink extends UnLitElement {
    @property({attribute: "href"})
    public href: string;
    @property({attribute: "target"})
    public target: string;

    public constructor(private nav: Nav = resolve(Nav)) {
        super();
    }

    public connectedCallback(): void {
        super.connectedCallback();

        if (!this.href || this.href.length === 0) {
            return;
        }

        this.style.cursor = "pointer";
        this.setAttribute("tabindex", "0");
        this.setAttribute("role", "link");

        this.addEventListener("click", (event) => {
            if (clickEventAlreadyHandledByChild(event, this)) {
                return;
            }

            this.navigate();
        });

        this.addEventListener("keydown", (event) => {
            if (event.key === "Enter") {
                event.preventDefault();
                this.navigate();
            }
        });
    }

    private navigate(): void {
        if (this.target === "_blank") {
            this.nav.redirectNewWindow(this.href);
        } else {
            this.nav.redirect(this.href);
        }
    }
}